export enum ErrorCode {
  LOGIN_FAILED = 'login_failed',
  SESSION_TIMED_OUT = 'session_timeout',
  TAN_FAILED = 'tan_failed',
  TECH_ERROR = 'tech_error',
  TRANSACTION_NOT_POSSIBLE = 'trans_not_possible',
  VALIDATION_FAILED = 'validation_failed',

  /* Our own codes */
  SCRIPT_ERROR = 'script_error',
  WIZARD_KEY_ERROR = 'wizard_key_error',
}
